import { render, staticRenderFns } from "./avatar_profile.vue?vue&type=template&id=00989597"
import script from "./avatar_profile.vue?vue&type=script&lang=js"
export * from "./avatar_profile.vue?vue&type=script&lang=js"
import style0 from "./avatar_profile.vue?vue&type=style&index=0&id=00989597&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports